<div class="alert alert-danger d-flex flex-row align-items-center mb-3">
  <div class="flex-grow-1"><strong><i class="fas fa-stop-circle"></i>{{ flag.Message }}</strong></div>
  @if (allowReactivation()) {
    <div>
      <button class="btn btn-warning btn-sm" (click)="reactivateNonworkableTaskType()">Reactivate</button>
    </div>
  }
</div>